import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { FeedbackRepository, FeedbackPayload } from './feedback-repository.service';

@Injectable({ providedIn: 'root' }) // globally available singleton
export class FeedbackService {
  constructor(private feedbackRepository: FeedbackRepository) {}

  submitFeedback(payload: FeedbackPayload, token: string): Observable<HttpResponse<string>> {
    return this.feedbackRepository.postFeedback(payload, token);
  }
}
